import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountService, ModalOverlayRef } from '@serviceos-ng/core';

@Component({
    selector: 'serviceos-web-client-verification',
    templateUrl: './client-verification.component.html',
    styleUrls: ['./client-verification.component.scss'],
})
export class ClientVerificationComponent implements OnInit {
    codeForm!: FormGroup;
    formSubmitted = false;
    public isSend = false;

    public confirmMsg: string[] = [];
    public successMsg: string[] = [];
    public errorMsg: string[] = [];
    public showLoader = false;
    public modalPayload: any = null;

    constructor(
        public modalRef: ModalOverlayRef,
        private fb: FormBuilder,
        private _accountService: AccountService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.codeForm = this.fb.group({
            code: ['', Validators.required],
        });

        const modalData = this.modalRef.configData;
        console.log('modalData on init: ', modalData);

        
        // Check warnings and extract is_send
        if (modalData?.warning?.length > 0) {
            this.modalPayload = modalData.warning[0].payload
            
            this.isSend = this.modalPayload?.verification?.is_send ?? null;
        }

        this.cdr.detectChanges();
    }

    get code() {
        return this.codeForm.get('code');
    }

    submit() {
        this.formSubmitted = true;

        if (this.codeForm.invalid) {
            return; // stop if invalid
        }

        this.confirmVerification();

        console.log('Code value:', this.code?.value); // use the value
    }

    public close() {
        this.modalRef.close();
    }

    public resend() {
        this.sendVerification();
    }


    // Send verification code
    public sendVerification() {
        this.isSend = true;
        const modalData = this.modalRef.configData;
        let verifyData: any = null;

        if (modalData?.warning && modalData.warning.length > 0) {
            // Get payload from first warning
            const payload = modalData.warning[0].payload;

            // Example: access verification info
            if (payload?.verification) {
                verifyData = {
                    type: payload?.verification?.type,
                    value: payload?.verification?.value
                }
            }
        }

        // Reset before request
        this.successMsg = [];
        this.errorMsg = [];

        this.showLoader = true;
        this.cdr.detectChanges();

        this._accountService.sendVerification(verifyData)
            .subscribe({
                next: (res) => {
                    this.showLoader = false;
                    console.log('sendVerificationCode updated successfully2', res);

                    if (res.success) {
                        res.success.forEach(s => this.successMsg.push(s.message));
                    }

                    if (res.error) {
                        res.error.forEach(e => this.errorMsg.push(e.message));
                    }

                    if (res.warning) {
                        res.warning.forEach(w => this.errorMsg.push(w.message));
                    }
                },
                error: (err) => {
                    this.showLoader = false;
                    console.error('sendVerificationailed to update code2', err);

                    if (err.error) {
                        // push all error messages
                        err.error.forEach(e => this.errorMsg.push(e.message));
                    } else {
                        this.errorMsg.push('Something went wrong. Please try again.');
                    }
                }
            });

    }
    
    // Confirm verification code
    public confirmVerification() {
        
        const modalData = this.modalRef.configData;
        let verifyData: any = null;

        if (modalData?.warning && modalData.warning.length > 0) {
            // Get payload from first warning
            const payload = modalData.warning[0].payload;

            // Example: access verification info
            if (payload?.verification) {

                verifyData = {
                    type: payload?.verification?.type,
                    value: payload?.verification?.value,
                    code: this.code?.value
                }
            }
        }

        // Reset before request
        this.confirmMsg = [];
        this.errorMsg = [];

        this.showLoader = true;
        this.cdr.detectChanges();

        this._accountService.confirmVerification(verifyData).subscribe({
            next: (res) => {
                this.showLoader = false;
                console.log('✅ confirmVerificationCode updated successfully', res);
                if (res.success) {
                    res.success.forEach(s => this.confirmMsg.push(s.message));
                    this.cdr.detectChanges();

                    setTimeout(() => {
                        this.close();
                    }, 2000);
                }
                if (res.error) {
                    res.error.forEach(e => this.errorMsg.push(e.message));
                }
                if (res.warning) {
                    res.warning.forEach(w => this.errorMsg.push(w.message));
                }
            },
            error: (err) => {
                this.showLoader = false;
                console.error('❌ confirmVerificationFailed to update code', err);
                if (err.error) {
                    err.error.forEach(e => this.errorMsg.push(e.message));
                } else {
                    this.errorMsg.push('Something went wrong. Please try again.');
                }
            }
        });

    }
}
